export enum ExpandableSection {
  CampaignName = 'campaign-name',
  SelectRecommendationType = 'select-recommendation-type',
  EmailVariables = 'email-variables',
  TrackingParameters = 'tracking-parameters',
  EmailDisplaySettings = 'email-display-settings',
  Layout = 'layout',
  Header = 'header',
  ProductCard = 'product-card',
  Button = 'button',
}
